export default __webpack_public_path__ + "static/media/notification-dot.c4811864.svg";